export default [
  {
    name: 'apply/amount',
    path: '/apply/amount',
    component() {
      return import('@/pages/apply/Amount.vue')
    },
  },
  {
    name: 'apply/complete',
    path: '/apply/complete',
    component() {
      return import('@/pages/apply/Complete.vue')
    },
  },
  {
    name: 'apply/complete/ver2',
    path: '/apply/complete/ver2',
    meta: {
      layout: 'DefaultLayoutFluid',
    },
    component() {
      return import('@/pages/common/guide/ReadyForService.vue')
    },
  },
  {
    name: 'apply/start',
    path: '/apply/start',
    component() {
      return import('@/pages/apply/Start.vue')
    },
  },
  {
    name: 'apply/wait',
    path: '/apply/wait',
    component() {
      return import('@/pages/apply/Wait.vue')
    },
  },
  // {
  //   name: 'apply/before',
  //   path: '/apply/before',
  //   component() {
  //     return import('@/pages/apply/Before.vue')
  //   },
  // },
  {
    name: 'apply/before',
    path: '/apply/before',
    meta: { design: { classes: ['px-0'] } },
    component() {
      return import('@/pages/apply/Before.vue')
    },
  },
]
